module.exports = __webpack_public_path__ + "files/37269fe0ae69c737e50aaba36e2c266e.png";